// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1StateSchema } from './v1/stateSchema';
import { v1StatesUpdateSchema } from './v1/states/updateSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateHourStatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("State ID"),
});

export const updateHourStateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description State updated
 */
export const updateHourState200Schema = z.lazy(() => v1StateSchema);

/**
 * @description Unauthorized
 */
export const updateHourState401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description State not found
 */
export const updateHourState404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation errors
 */
export const updateHourState422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateHourStateMutationRequestSchema = z.lazy(() => v1StatesUpdateSchema);

export const updateHourStateMutationResponseSchema = z.lazy(() => updateHourState200Schema);
